module.exports = __webpack_public_path__ + "assets/img/zhinengwenda.5da6dd3a.png";